import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import infoIcon from '@fortawesome/fontawesome-free-solid/faInfo'
import phoneIcon from '@fortawesome/fontawesome-free-solid/faPhone'
import emailIcon from '@fortawesome/fontawesome-free-regular/faEnvelope'
import urlIcon from '@fortawesome/fontawesome-free-solid/faLink'

import { CircularProgress } from '../../../common'
import MenuHeader from '../../../containers/MenuHeader'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'

import * as Constants from '../../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'
import * as offlineModeActions from '../../../../actions/OfflineMode'
import * as communityInformationActions from '../../../../actions/CommunityInformation'

class CommunityInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth
    }
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    const { history, user, offlineMode, data } = this.props
    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.communityInformationFetched) {
      this.props.tryGetCommunityInformation(user.token)
    }

    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  renderItems() {
    const { data, config, user } = this.props

    const items = data.communityInformationItems
    // const items = data.communityInformationItems.sort((o1, o2) => o1.sort - o2.sort)

    if (items.length === 0 && user.isAdmin) {
      return (
        <p style={{ textAlign: 'center' }}>
          {Strings.default.NO_INFORMATION_ADMIN[config.language]}
        </p>
      )
    }

    if (items.length === 0) {
      return (
        <p style={{ textAlign: 'center' }}>
          {Strings.default.NO_INFORMATION[config.language]}
        </p>
      )
    }

    return items.map(item => <Item data={item} language={config.language} />)
  }

  renderContent() {
    const { width } = this.state
    const { user, config, offlineMode, data } = this.props

    if (!data.communityInformationFetched) {
      return <CircularProgress />
    }

    if (user.fetched || user.offlineModeSignedIn) {
      return (
        <div style={Styles.default.containerStyle}>
          {width < 800 ? null : (
            <div
              style={{
                ...Styles.default.informationContainerStyle,
                paddingTop: offlineMode ? 168 : 128
              }}
            >
              <FontAwesomeIcon
                icon={infoIcon}
                style={{ fontSize: 40 }}
                color={'#f4f4f8'}
              />
              <h2 className={'centerText'} style={Styles.default.textStyle}>
                {Strings.default.INFORMATION[config.language]}
              </h2>
              <p className={'centerText'} style={Styles.default.textStyle}>
                {Strings.default.INFORMATION_FROM_YOUR_BOARD[config.language]}
              </p>
            </div>
          )}
          <div style={Styles.default.informationItemsContainerStyle}>
            {this.renderItems()}
          </div>
        </div>
      )
    }
  }

  render() {
    const { config, history, user, offlineMode } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    if (!user.fetched) {
      return <CircularProgress />
    }

    return (
      <MenuHeader
        selected={Constants.INFO_BOARD_FOCUSED}
        header={Strings.default.INFO_BOARD[config.language]}
        history={history}
      >
        <div className={'ContainerCenteredWhite'} style={{ minHeight: '100%' }}>
          <OfflineModeHeader history={history} />
          {this.renderContent()}
        </div>
      </MenuHeader>
    )
  }
}

const Item = ({ data, language }) => {
  const { title, titleEN, information, informationEN, type } = data

  let icon = null
  let color = '#3b424d'
  let additionalStyle = {}

  switch (type) {
    case 'phone':
      icon = phoneIcon
      color = Constants.WHITE_LABEL.colors.primary
      break
    case 'email':
      icon = emailIcon
      break
    case 'text':
      icon = infoIcon
      break
    case 'url':
      icon = urlIcon
      additionalStyle = {
        textDecorationLine: 'underline',
        color: '#3fa6c1'
      }
      break
    default:
  }

  return (
    <div style={Styles.default.itemContainerStyle}>
      <div style={Styles.default.iconContainerStyle}>
        <FontAwesomeIcon icon={icon} style={{ fontSize: 30 }} color={color} />
      </div>
      <div style={Styles.default.innerItemContainerStyle}>
        <p style={Styles.default.itemHeaderStyle}>
          {language === 'SE' ? title : titleEN}
        </p>
        <p style={{ ...Styles.default.itemTextStyle, ...additionalStyle }}>
          {language === 'SE' ? information : informationEN}
        </p>
      </div>
    </div>
  )
}

function mapStateToProps({ user, data, config }) {
  return { user, data, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...offlineModeActions, ...communityInformationActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityInformation)



// WEBPACK FOOTER //
// ./src/components/pages/communityInformation/CommunityInformation/index.js